/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as EditorIndexImport } from './routes/editor/index'
import { Route as ConsentIndexImport } from './routes/consent/index'
import { Route as AuthIndexImport } from './routes/auth/index'
import { Route as AdminIndexImport } from './routes/admin/index'
import { Route as EditorProceduresImport } from './routes/editor/procedures'
import { Route as EditorCategoriesImport } from './routes/editor/categories'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AdminUsersImport } from './routes/admin/users'
import { Route as AdminReportImport } from './routes/admin/report'
import { Route as AdminFeedbackImport } from './routes/admin/feedback'
import { Route as EducationalMaterialIndexImport } from './routes/educational/material/index'
import { Route as AdminConfigIndexImport } from './routes/admin/config/index'
import { Route as EditorProceduresNewImport } from './routes/editor/procedures/new'
import { Route as AdminUsersNewImport } from './routes/admin/users/new'
import { Route as EditorProceduresProcedureIdIndexImport } from './routes/editor/procedures/$procedureId/index'
import { Route as EditorProceduresProcedureIdEditImport } from './routes/editor/procedures/$procedureId/edit'
import { Route as EditorProceduresProcedureIdEducationalMaterialNewImport } from './routes/editor/procedures/$procedureId/educational-material/new'
import { Route as EditorProceduresProcedureIdConsentNewImport } from './routes/editor/procedures/$procedureId/consent/new'
import { Route as EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditImport } from './routes/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit'
import { Route as EditorProceduresProcedureIdConsentConsentIdEditImport } from './routes/editor/procedures/$procedureId/consent/$consentId/edit'

// Create Virtual Routes

const EducationalIndexLazyImport = createFileRoute('/educational/')()
const EditorProceduresIndexLazyImport = createFileRoute('/editor/procedures/')()
const AdminUsersIndexLazyImport = createFileRoute('/admin/users/')()

// Create/Update Routes

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const EducationalIndexLazyRoute = EducationalIndexLazyImport.update({
  id: '/educational/',
  path: '/educational/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/educational/index.lazy').then((d) => d.Route),
)

const EditorIndexRoute = EditorIndexImport.update({
  id: '/editor/',
  path: '/editor/',
  getParentRoute: () => rootRoute,
} as any)

const ConsentIndexRoute = ConsentIndexImport.update({
  id: '/consent/',
  path: '/consent/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/consent/index.lazy').then((d) => d.Route))

const AuthIndexRoute = AuthIndexImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRoute,
} as any)

const AdminIndexRoute = AdminIndexImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRoute,
} as any)

const EditorProceduresRoute = EditorProceduresImport.update({
  id: '/editor/procedures',
  path: '/editor/procedures',
  getParentRoute: () => rootRoute,
} as any)

const EditorCategoriesRoute = EditorCategoriesImport.update({
  id: '/editor/categories',
  path: '/editor/categories',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/editor/categories.lazy').then((d) => d.Route),
)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/auth/login.lazy').then((d) => d.Route))

const AdminUsersRoute = AdminUsersImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRoute,
} as any)

const AdminReportRoute = AdminReportImport.update({
  id: '/admin/report',
  path: '/admin/report',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/admin/report.lazy').then((d) => d.Route))

const AdminFeedbackRoute = AdminFeedbackImport.update({
  id: '/admin/feedback',
  path: '/admin/feedback',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/admin/feedback.lazy').then((d) => d.Route),
)

const EditorProceduresIndexLazyRoute = EditorProceduresIndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EditorProceduresRoute,
} as any).lazy(() =>
  import('./routes/editor/procedures/index.lazy').then((d) => d.Route),
)

const AdminUsersIndexLazyRoute = AdminUsersIndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminUsersRoute,
} as any).lazy(() =>
  import('./routes/admin/users/index.lazy').then((d) => d.Route),
)

const EducationalMaterialIndexRoute = EducationalMaterialIndexImport.update({
  id: '/educational/material/',
  path: '/educational/material/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/educational/material/index.lazy').then((d) => d.Route),
)

const AdminConfigIndexRoute = AdminConfigIndexImport.update({
  id: '/admin/config/',
  path: '/admin/config/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/admin/config/index.lazy').then((d) => d.Route),
)

const EditorProceduresNewRoute = EditorProceduresNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => EditorProceduresRoute,
} as any).lazy(() =>
  import('./routes/editor/procedures/new.lazy').then((d) => d.Route),
)

const AdminUsersNewRoute = AdminUsersNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminUsersRoute,
} as any).lazy(() =>
  import('./routes/admin/users/new.lazy').then((d) => d.Route),
)

const EditorProceduresProcedureIdIndexRoute =
  EditorProceduresProcedureIdIndexImport.update({
    id: '/$procedureId/',
    path: '/$procedureId/',
    getParentRoute: () => EditorProceduresRoute,
  } as any).lazy(() =>
    import('./routes/editor/procedures/$procedureId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const EditorProceduresProcedureIdEditRoute =
  EditorProceduresProcedureIdEditImport.update({
    id: '/$procedureId/edit',
    path: '/$procedureId/edit',
    getParentRoute: () => EditorProceduresRoute,
  } as any).lazy(() =>
    import('./routes/editor/procedures/$procedureId/edit.lazy').then(
      (d) => d.Route,
    ),
  )

const EditorProceduresProcedureIdEducationalMaterialNewRoute =
  EditorProceduresProcedureIdEducationalMaterialNewImport.update({
    id: '/$procedureId/educational-material/new',
    path: '/$procedureId/educational-material/new',
    getParentRoute: () => EditorProceduresRoute,
  } as any).lazy(() =>
    import(
      './routes/editor/procedures/$procedureId/educational-material/new.lazy'
    ).then((d) => d.Route),
  )

const EditorProceduresProcedureIdConsentNewRoute =
  EditorProceduresProcedureIdConsentNewImport.update({
    id: '/$procedureId/consent/new',
    path: '/$procedureId/consent/new',
    getParentRoute: () => EditorProceduresRoute,
  } as any).lazy(() =>
    import('./routes/editor/procedures/$procedureId/consent/new.lazy').then(
      (d) => d.Route,
    ),
  )

const EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditRoute =
  EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditImport.update(
    {
      id: '/$procedureId/educational-material/$educationalMaterialId/edit',
      path: '/$procedureId/educational-material/$educationalMaterialId/edit',
      getParentRoute: () => EditorProceduresRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit.lazy'
    ).then((d) => d.Route),
  )

const EditorProceduresProcedureIdConsentConsentIdEditRoute =
  EditorProceduresProcedureIdConsentConsentIdEditImport.update({
    id: '/$procedureId/consent/$consentId/edit',
    path: '/$procedureId/consent/$consentId/edit',
    getParentRoute: () => EditorProceduresRoute,
  } as any).lazy(() =>
    import(
      './routes/editor/procedures/$procedureId/consent/$consentId/edit.lazy'
    ).then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/feedback': {
      id: '/admin/feedback'
      path: '/admin/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AdminFeedbackImport
      parentRoute: typeof rootRoute
    }
    '/admin/report': {
      id: '/admin/report'
      path: '/admin/report'
      fullPath: '/admin/report'
      preLoaderRoute: typeof AdminReportImport
      parentRoute: typeof rootRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersImport
      parentRoute: typeof rootRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/editor/categories': {
      id: '/editor/categories'
      path: '/editor/categories'
      fullPath: '/editor/categories'
      preLoaderRoute: typeof EditorCategoriesImport
      parentRoute: typeof rootRoute
    }
    '/editor/procedures': {
      id: '/editor/procedures'
      path: '/editor/procedures'
      fullPath: '/editor/procedures'
      preLoaderRoute: typeof EditorProceduresImport
      parentRoute: typeof rootRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexImport
      parentRoute: typeof rootRoute
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof rootRoute
    }
    '/consent/': {
      id: '/consent/'
      path: '/consent'
      fullPath: '/consent'
      preLoaderRoute: typeof ConsentIndexImport
      parentRoute: typeof rootRoute
    }
    '/editor/': {
      id: '/editor/'
      path: '/editor'
      fullPath: '/editor'
      preLoaderRoute: typeof EditorIndexImport
      parentRoute: typeof rootRoute
    }
    '/educational/': {
      id: '/educational/'
      path: '/educational'
      fullPath: '/educational'
      preLoaderRoute: typeof EducationalIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin/users/new': {
      id: '/admin/users/new'
      path: '/new'
      fullPath: '/admin/users/new'
      preLoaderRoute: typeof AdminUsersNewImport
      parentRoute: typeof AdminUsersImport
    }
    '/editor/procedures/new': {
      id: '/editor/procedures/new'
      path: '/new'
      fullPath: '/editor/procedures/new'
      preLoaderRoute: typeof EditorProceduresNewImport
      parentRoute: typeof EditorProceduresImport
    }
    '/admin/config/': {
      id: '/admin/config/'
      path: '/admin/config'
      fullPath: '/admin/config'
      preLoaderRoute: typeof AdminConfigIndexImport
      parentRoute: typeof rootRoute
    }
    '/educational/material/': {
      id: '/educational/material/'
      path: '/educational/material'
      fullPath: '/educational/material'
      preLoaderRoute: typeof EducationalMaterialIndexImport
      parentRoute: typeof rootRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexLazyImport
      parentRoute: typeof AdminUsersImport
    }
    '/editor/procedures/': {
      id: '/editor/procedures/'
      path: '/'
      fullPath: '/editor/procedures/'
      preLoaderRoute: typeof EditorProceduresIndexLazyImport
      parentRoute: typeof EditorProceduresImport
    }
    '/editor/procedures/$procedureId/edit': {
      id: '/editor/procedures/$procedureId/edit'
      path: '/$procedureId/edit'
      fullPath: '/editor/procedures/$procedureId/edit'
      preLoaderRoute: typeof EditorProceduresProcedureIdEditImport
      parentRoute: typeof EditorProceduresImport
    }
    '/editor/procedures/$procedureId/': {
      id: '/editor/procedures/$procedureId/'
      path: '/$procedureId'
      fullPath: '/editor/procedures/$procedureId'
      preLoaderRoute: typeof EditorProceduresProcedureIdIndexImport
      parentRoute: typeof EditorProceduresImport
    }
    '/editor/procedures/$procedureId/consent/new': {
      id: '/editor/procedures/$procedureId/consent/new'
      path: '/$procedureId/consent/new'
      fullPath: '/editor/procedures/$procedureId/consent/new'
      preLoaderRoute: typeof EditorProceduresProcedureIdConsentNewImport
      parentRoute: typeof EditorProceduresImport
    }
    '/editor/procedures/$procedureId/educational-material/new': {
      id: '/editor/procedures/$procedureId/educational-material/new'
      path: '/$procedureId/educational-material/new'
      fullPath: '/editor/procedures/$procedureId/educational-material/new'
      preLoaderRoute: typeof EditorProceduresProcedureIdEducationalMaterialNewImport
      parentRoute: typeof EditorProceduresImport
    }
    '/editor/procedures/$procedureId/consent/$consentId/edit': {
      id: '/editor/procedures/$procedureId/consent/$consentId/edit'
      path: '/$procedureId/consent/$consentId/edit'
      fullPath: '/editor/procedures/$procedureId/consent/$consentId/edit'
      preLoaderRoute: typeof EditorProceduresProcedureIdConsentConsentIdEditImport
      parentRoute: typeof EditorProceduresImport
    }
    '/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit': {
      id: '/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit'
      path: '/$procedureId/educational-material/$educationalMaterialId/edit'
      fullPath: '/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit'
      preLoaderRoute: typeof EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditImport
      parentRoute: typeof EditorProceduresImport
    }
  }
}

// Create and export the route tree

interface AdminUsersRouteChildren {
  AdminUsersNewRoute: typeof AdminUsersNewRoute
  AdminUsersIndexLazyRoute: typeof AdminUsersIndexLazyRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersNewRoute: AdminUsersNewRoute,
  AdminUsersIndexLazyRoute: AdminUsersIndexLazyRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface EditorProceduresRouteChildren {
  EditorProceduresNewRoute: typeof EditorProceduresNewRoute
  EditorProceduresIndexLazyRoute: typeof EditorProceduresIndexLazyRoute
  EditorProceduresProcedureIdEditRoute: typeof EditorProceduresProcedureIdEditRoute
  EditorProceduresProcedureIdIndexRoute: typeof EditorProceduresProcedureIdIndexRoute
  EditorProceduresProcedureIdConsentNewRoute: typeof EditorProceduresProcedureIdConsentNewRoute
  EditorProceduresProcedureIdEducationalMaterialNewRoute: typeof EditorProceduresProcedureIdEducationalMaterialNewRoute
  EditorProceduresProcedureIdConsentConsentIdEditRoute: typeof EditorProceduresProcedureIdConsentConsentIdEditRoute
  EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditRoute: typeof EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditRoute
}

const EditorProceduresRouteChildren: EditorProceduresRouteChildren = {
  EditorProceduresNewRoute: EditorProceduresNewRoute,
  EditorProceduresIndexLazyRoute: EditorProceduresIndexLazyRoute,
  EditorProceduresProcedureIdEditRoute: EditorProceduresProcedureIdEditRoute,
  EditorProceduresProcedureIdIndexRoute: EditorProceduresProcedureIdIndexRoute,
  EditorProceduresProcedureIdConsentNewRoute:
    EditorProceduresProcedureIdConsentNewRoute,
  EditorProceduresProcedureIdEducationalMaterialNewRoute:
    EditorProceduresProcedureIdEducationalMaterialNewRoute,
  EditorProceduresProcedureIdConsentConsentIdEditRoute:
    EditorProceduresProcedureIdConsentConsentIdEditRoute,
  EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditRoute:
    EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditRoute,
}

const EditorProceduresRouteWithChildren =
  EditorProceduresRoute._addFileChildren(EditorProceduresRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/report': typeof AdminReportRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/editor/categories': typeof EditorCategoriesRoute
  '/editor/procedures': typeof EditorProceduresRouteWithChildren
  '/admin': typeof AdminIndexRoute
  '/auth': typeof AuthIndexRoute
  '/consent': typeof ConsentIndexRoute
  '/editor': typeof EditorIndexRoute
  '/educational': typeof EducationalIndexLazyRoute
  '/admin/users/new': typeof AdminUsersNewRoute
  '/editor/procedures/new': typeof EditorProceduresNewRoute
  '/admin/config': typeof AdminConfigIndexRoute
  '/educational/material': typeof EducationalMaterialIndexRoute
  '/admin/users/': typeof AdminUsersIndexLazyRoute
  '/editor/procedures/': typeof EditorProceduresIndexLazyRoute
  '/editor/procedures/$procedureId/edit': typeof EditorProceduresProcedureIdEditRoute
  '/editor/procedures/$procedureId': typeof EditorProceduresProcedureIdIndexRoute
  '/editor/procedures/$procedureId/consent/new': typeof EditorProceduresProcedureIdConsentNewRoute
  '/editor/procedures/$procedureId/educational-material/new': typeof EditorProceduresProcedureIdEducationalMaterialNewRoute
  '/editor/procedures/$procedureId/consent/$consentId/edit': typeof EditorProceduresProcedureIdConsentConsentIdEditRoute
  '/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit': typeof EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/report': typeof AdminReportRoute
  '/auth/login': typeof AuthLoginRoute
  '/editor/categories': typeof EditorCategoriesRoute
  '/admin': typeof AdminIndexRoute
  '/auth': typeof AuthIndexRoute
  '/consent': typeof ConsentIndexRoute
  '/editor': typeof EditorIndexRoute
  '/educational': typeof EducationalIndexLazyRoute
  '/admin/users/new': typeof AdminUsersNewRoute
  '/editor/procedures/new': typeof EditorProceduresNewRoute
  '/admin/config': typeof AdminConfigIndexRoute
  '/educational/material': typeof EducationalMaterialIndexRoute
  '/admin/users': typeof AdminUsersIndexLazyRoute
  '/editor/procedures': typeof EditorProceduresIndexLazyRoute
  '/editor/procedures/$procedureId/edit': typeof EditorProceduresProcedureIdEditRoute
  '/editor/procedures/$procedureId': typeof EditorProceduresProcedureIdIndexRoute
  '/editor/procedures/$procedureId/consent/new': typeof EditorProceduresProcedureIdConsentNewRoute
  '/editor/procedures/$procedureId/educational-material/new': typeof EditorProceduresProcedureIdEducationalMaterialNewRoute
  '/editor/procedures/$procedureId/consent/$consentId/edit': typeof EditorProceduresProcedureIdConsentConsentIdEditRoute
  '/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit': typeof EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/report': typeof AdminReportRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/editor/categories': typeof EditorCategoriesRoute
  '/editor/procedures': typeof EditorProceduresRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/consent/': typeof ConsentIndexRoute
  '/editor/': typeof EditorIndexRoute
  '/educational/': typeof EducationalIndexLazyRoute
  '/admin/users/new': typeof AdminUsersNewRoute
  '/editor/procedures/new': typeof EditorProceduresNewRoute
  '/admin/config/': typeof AdminConfigIndexRoute
  '/educational/material/': typeof EducationalMaterialIndexRoute
  '/admin/users/': typeof AdminUsersIndexLazyRoute
  '/editor/procedures/': typeof EditorProceduresIndexLazyRoute
  '/editor/procedures/$procedureId/edit': typeof EditorProceduresProcedureIdEditRoute
  '/editor/procedures/$procedureId/': typeof EditorProceduresProcedureIdIndexRoute
  '/editor/procedures/$procedureId/consent/new': typeof EditorProceduresProcedureIdConsentNewRoute
  '/editor/procedures/$procedureId/educational-material/new': typeof EditorProceduresProcedureIdEducationalMaterialNewRoute
  '/editor/procedures/$procedureId/consent/$consentId/edit': typeof EditorProceduresProcedureIdConsentConsentIdEditRoute
  '/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit': typeof EditorProceduresProcedureIdEducationalMaterialEducationalMaterialIdEditRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin/feedback'
    | '/admin/report'
    | '/admin/users'
    | '/auth/login'
    | '/editor/categories'
    | '/editor/procedures'
    | '/admin'
    | '/auth'
    | '/consent'
    | '/editor'
    | '/educational'
    | '/admin/users/new'
    | '/editor/procedures/new'
    | '/admin/config'
    | '/educational/material'
    | '/admin/users/'
    | '/editor/procedures/'
    | '/editor/procedures/$procedureId/edit'
    | '/editor/procedures/$procedureId'
    | '/editor/procedures/$procedureId/consent/new'
    | '/editor/procedures/$procedureId/educational-material/new'
    | '/editor/procedures/$procedureId/consent/$consentId/edit'
    | '/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin/feedback'
    | '/admin/report'
    | '/auth/login'
    | '/editor/categories'
    | '/admin'
    | '/auth'
    | '/consent'
    | '/editor'
    | '/educational'
    | '/admin/users/new'
    | '/editor/procedures/new'
    | '/admin/config'
    | '/educational/material'
    | '/admin/users'
    | '/editor/procedures'
    | '/editor/procedures/$procedureId/edit'
    | '/editor/procedures/$procedureId'
    | '/editor/procedures/$procedureId/consent/new'
    | '/editor/procedures/$procedureId/educational-material/new'
    | '/editor/procedures/$procedureId/consent/$consentId/edit'
    | '/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit'
  id:
    | '__root__'
    | '/'
    | '/admin/feedback'
    | '/admin/report'
    | '/admin/users'
    | '/auth/login'
    | '/editor/categories'
    | '/editor/procedures'
    | '/admin/'
    | '/auth/'
    | '/consent/'
    | '/editor/'
    | '/educational/'
    | '/admin/users/new'
    | '/editor/procedures/new'
    | '/admin/config/'
    | '/educational/material/'
    | '/admin/users/'
    | '/editor/procedures/'
    | '/editor/procedures/$procedureId/edit'
    | '/editor/procedures/$procedureId/'
    | '/editor/procedures/$procedureId/consent/new'
    | '/editor/procedures/$procedureId/educational-material/new'
    | '/editor/procedures/$procedureId/consent/$consentId/edit'
    | '/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminFeedbackRoute: typeof AdminFeedbackRoute
  AdminReportRoute: typeof AdminReportRoute
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AuthLoginRoute: typeof AuthLoginRoute
  EditorCategoriesRoute: typeof EditorCategoriesRoute
  EditorProceduresRoute: typeof EditorProceduresRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AuthIndexRoute: typeof AuthIndexRoute
  ConsentIndexRoute: typeof ConsentIndexRoute
  EditorIndexRoute: typeof EditorIndexRoute
  EducationalIndexLazyRoute: typeof EducationalIndexLazyRoute
  AdminConfigIndexRoute: typeof AdminConfigIndexRoute
  EducationalMaterialIndexRoute: typeof EducationalMaterialIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminFeedbackRoute: AdminFeedbackRoute,
  AdminReportRoute: AdminReportRoute,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AuthLoginRoute: AuthLoginRoute,
  EditorCategoriesRoute: EditorCategoriesRoute,
  EditorProceduresRoute: EditorProceduresRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AuthIndexRoute: AuthIndexRoute,
  ConsentIndexRoute: ConsentIndexRoute,
  EditorIndexRoute: EditorIndexRoute,
  EducationalIndexLazyRoute: EducationalIndexLazyRoute,
  AdminConfigIndexRoute: AdminConfigIndexRoute,
  EducationalMaterialIndexRoute: EducationalMaterialIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/admin/feedback",
        "/admin/report",
        "/admin/users",
        "/auth/login",
        "/editor/categories",
        "/editor/procedures",
        "/admin/",
        "/auth/",
        "/consent/",
        "/editor/",
        "/educational/",
        "/admin/config/",
        "/educational/material/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/admin/feedback": {
      "filePath": "admin/feedback.tsx"
    },
    "/admin/report": {
      "filePath": "admin/report.tsx"
    },
    "/admin/users": {
      "filePath": "admin/users.tsx",
      "children": [
        "/admin/users/new",
        "/admin/users/"
      ]
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/editor/categories": {
      "filePath": "editor/categories.tsx"
    },
    "/editor/procedures": {
      "filePath": "editor/procedures.tsx",
      "children": [
        "/editor/procedures/new",
        "/editor/procedures/",
        "/editor/procedures/$procedureId/edit",
        "/editor/procedures/$procedureId/",
        "/editor/procedures/$procedureId/consent/new",
        "/editor/procedures/$procedureId/educational-material/new",
        "/editor/procedures/$procedureId/consent/$consentId/edit",
        "/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit"
      ]
    },
    "/admin/": {
      "filePath": "admin/index.tsx"
    },
    "/auth/": {
      "filePath": "auth/index.tsx"
    },
    "/consent/": {
      "filePath": "consent/index.tsx"
    },
    "/editor/": {
      "filePath": "editor/index.tsx"
    },
    "/educational/": {
      "filePath": "educational/index.lazy.tsx"
    },
    "/admin/users/new": {
      "filePath": "admin/users/new.tsx",
      "parent": "/admin/users"
    },
    "/editor/procedures/new": {
      "filePath": "editor/procedures/new.tsx",
      "parent": "/editor/procedures"
    },
    "/admin/config/": {
      "filePath": "admin/config/index.tsx"
    },
    "/educational/material/": {
      "filePath": "educational/material/index.tsx"
    },
    "/admin/users/": {
      "filePath": "admin/users/index.lazy.tsx",
      "parent": "/admin/users"
    },
    "/editor/procedures/": {
      "filePath": "editor/procedures/index.lazy.tsx",
      "parent": "/editor/procedures"
    },
    "/editor/procedures/$procedureId/edit": {
      "filePath": "editor/procedures/$procedureId/edit.tsx",
      "parent": "/editor/procedures"
    },
    "/editor/procedures/$procedureId/": {
      "filePath": "editor/procedures/$procedureId/index.tsx",
      "parent": "/editor/procedures"
    },
    "/editor/procedures/$procedureId/consent/new": {
      "filePath": "editor/procedures/$procedureId/consent/new.tsx",
      "parent": "/editor/procedures"
    },
    "/editor/procedures/$procedureId/educational-material/new": {
      "filePath": "editor/procedures/$procedureId/educational-material/new.tsx",
      "parent": "/editor/procedures"
    },
    "/editor/procedures/$procedureId/consent/$consentId/edit": {
      "filePath": "editor/procedures/$procedureId/consent/$consentId/edit.tsx",
      "parent": "/editor/procedures"
    },
    "/editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit": {
      "filePath": "editor/procedures/$procedureId/educational-material/$educationalMaterialId/edit.tsx",
      "parent": "/editor/procedures"
    }
  }
}
ROUTE_MANIFEST_END */
